import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { MessagesService } from '../../../services/api.services';

@Component({
  selector: 'app-csite-escritorio',
  templateUrl: './csite-escritorio.component.html',
  styleUrls: ['./csite-escritorio.component.scss'],
})
export class CsiteEscritorioComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  @Input() csiteData;
  ColumnMode = ColumnMode;

  constructor(private router: Router,
              private messages: MessagesService,
              ) {}

  ngOnInit() {}

  ver(row: any) {
    this.router.navigate(['main', 'inci-postventa', row.id]);
  }

  getCellClass({ row, column, value }): any {
    if (column.prop === 'date_30_qty' && value > 0) {
      return {
        'warning-issues': true,
        'cell-center-position': true,
      };
    } else if (column.prop === 'no_date_30_qty' && value > 0) {
      return {
        'danger-issues': true,
        'cell-center-position': true,
      };
    }else if ((column.prop === 'date_qty' || column.prop === 'no_date_qty'
                || column.prop === 'total' || column.prop === 'date_30_qty'
                || column.prop === 'no_date_30_qty') && value === 0) {
      return {
        'zero-issues': true,
        'cell-center-position': true,
      };
    } else {
      return {
        'cell-center-position': true,
      };
    }
  }

  getHeaderClass({ row, column, value }): any {
    return {
      'cell-center-position': true
    };

  }
}
